
/** 
* This file has been auto-generated by '@kontent-ai/model-generator@8.1.1'.
* 
* (c) Kontent.ai
*  
* -------------------------------------------------------------------------------
* 
* Project: UnumUK Employer Portal
* Environment: Dev (Previously Phase 2)
* Id: a5beabf7-cb3f-0126-9900-a0a631d69346
* 
* -------------------------------------------------------------------------------
**/

import type { Elements } from '@kontent-ai/delivery-sdk';
import type { CoreContentType } from "../system/index.js";
import type {
  NavInternalLink,
  NavExternalLink,
  MediaAsset,
  MediaExternalVideo,
} from "./index.js";
import type { Products } from "../taxonomies/index.js";

/**
 * 🏗️ Component // Feature
 *
 * Id: e104f010-abec-4328-9743-3e9ad0c3971b
 * Codename: feature
 */
export type ComponentFeature = CoreContentType<
    ComponentFeatureElementCodenames,
    {
        /**
         * Title
         *
         * Type: text
         * Required: true
         * Codename: title
         * Id: 341edd8a-3e31-468e-99ac-1ade097d24ae
         */
        readonly title: Elements.TextElement;
        /**
         * Body
         *
         * Type: rich_text
         * Required: true
         * Codename: body
         * Id: 6269fea5-5cc7-4182-bd93-397adc68bab9
         */
        readonly body: Elements.RichTextElement<NavInternalLink | NavExternalLink>;
        /**
         * Asset
         *
         * Type: modular_content
         * Required: true
         * Codename: asset
         * Id: 496e81b1-8398-44f2-8ec3-07630d66e288
         */
        readonly asset: Elements.LinkedItemsElement<MediaAsset | MediaExternalVideo>;
        /**
         * CTAs
         *
         * Type: modular_content
         * Required: false
         * Codename: ctas
         * Id: 286c40ad-7ca0-449a-9681-ccb0d4e2d3af
         */
        readonly ctas: Elements.LinkedItemsElement<NavInternalLink | NavExternalLink>;
        /**
         * Layout
         *
         * Type: multiple_choice
         * Required: true
         * Codename: layout
         * Id: df324588-b84d-4d73-9bb4-8deafff39c78
         */
        readonly layout: Elements.MultipleChoiceElement<'trailing_asset' | 'leading_asset'>;
        /**
         * Products
         *
         * Type: taxonomy
         * Required: false
         * Codename: products
         * Id: 51ab3675-fa22-46a9-b810-459b3797a7cb
         * Guidelines: • Restrict the visibility of this content to selected products. • If no products are selected, the content will be visible to all users.
         */
        readonly products: Elements.TaxonomyElement<Products, 'products'>;
    },
    'feature'
>;

/**
 * Type representing all available element codenames for 🏗️ Component // Feature
 */
export type ComponentFeatureElementCodenames = 'title' | 'body' | 'asset' | 'ctas' | 'layout' | 'products';

/**
 * Type guard for 🏗️ Component // Feature
 *
 * Id: e104f010-abec-4328-9743-3e9ad0c3971b
 * Codename: feature
 */
export function isComponentFeature(item: CoreContentType | undefined | null): item is ComponentFeature {
    return item?.system?.type === 'feature';
}
